(function () {
  if (window.__zproUpsellInitialized) return;
  window.__zproUpsellInitialized = true;

  var SUPPRESS_ATTEMPTS = [0, 50, 120, 250, 400, 700, 1100, 1800];
  var isUpsellLockActive = false;
  var upsellDispatchUntil = 0;

  function hasUpsellPopup() {
    return Boolean(document.querySelector('[data-zpro-upsell-popup]'));
  }

  function isCartAddUrl(url) {
    return url && /cart\/add/i.test(String(url));
  }

  function isCartAddFailurePayload(data) {
    if (!data || typeof data !== 'object') return true;
    var s = data.status;
    if (s === 422 || s === '422') return true;
    if (typeof s === 'number' && s >= 400) return true;
    return false;
  }

  function getProductIdsFromCartAddPayloadForTierSkip(data) {
    var ids = [];
    if (!data || typeof data !== 'object') return ids;
    if (data.product_id != null) ids.push(String(data.product_id));
    if (Array.isArray(data.items)) {
      data.items.forEach(function (it) {
        if (it && it.product_id != null) ids.push(String(it.product_id));
      });
    }
    return ids;
  }

  function isMiniCartSubscriptionTierProductAddForUpsell(data) {
    var form = document.querySelector('#mini-cart .minicart-form');
    if (!form) return false;
    var tierOnePid = form.getAttribute('data-st-tier-one-product-id');
    var tierMultiPid = form.getAttribute('data-st-tier-multi-product-id');
    if ((!tierOnePid || tierOnePid === '') && (!tierMultiPid || tierMultiPid === '')) return false;
    var added = getProductIdsFromCartAddPayloadForTierSkip(data);
    for (var i = 0; i < added.length; i++) {
      var p = added[i];
      if (tierOnePid && p === String(tierOnePid)) return true;
      if (tierMultiPid && p === String(tierMultiPid)) return true;
    }
    return false;
  }

  function dispatchZproUpsellFromCartResponse(data) {
    if (!hasUpsellPopup()) return false;
    if (window.__zproSuppressNextUpsellPopup) {
      try {
        delete window.__zproSuppressNextUpsellPopup;
      } catch (e) {
        window.__zproSuppressNextUpsellPopup = undefined;
      }
      return false;
    }
    if (isCartAddFailurePayload(data)) return false;
    if (isMiniCartSubscriptionTierProductAddForUpsell(data)) return false;
    if (window.__zproShowUpsellAfterCartAdd !== true) return false;
    var now = Date.now();
    if (now < upsellDispatchUntil) return false;
    upsellDispatchUntil = now + 600;
    document.dispatchEvent(
      new CustomEvent('zpro:upsell:added', {
        detail: { response: data },
      })
    );
    return true;
  }

  /** Fetch/XHR hooks are installed inline in zpro-product-details.liquid (runs earlier than deferred apps). */
  if (!window.__zproUpsellEarlyHooks) {
    if (!window.__zproUpsellFetchHooked) {
      window.__zproUpsellFetchHooked = true;
      var nativeFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        return nativeFetch(input, init).then(function (response) {
          try {
            var url = typeof input === 'string' ? input : input && (input.url || String(input));
            if (!isCartAddUrl(url)) return response;
            var method = 'GET';
            if (init && init.method) method = String(init.method).toUpperCase();
            if (typeof input !== 'string' && input && input.method) method = String(input.method).toUpperCase();
            if (method !== 'POST' && method !== 'PUT') return response;
            if (!response.ok) return response;
            return response
              .clone()
              .json()
              .then(function (data) {
                if (isMiniCartSubscriptionTierProductAddForUpsell(data)) {
                  return response;
                }
                if (dispatchZproUpsellFromCartResponse(data)) {
                  activateUpsellLock();
                }
                return response;
              })
              .catch(function () {
                return response;
              });
          } catch (e) {
            return response;
          }
        });
      };
    }

    if (!window.__zproUpsellXHRHooked) {
      window.__zproUpsellXHRHooked = true;
      var XHR = XMLHttpRequest.prototype;
      var xhrOpen = XHR.open;
      var xhrSend = XHR.send;
      XHR.open = function (method, url) {
        this.__zproUpsellUrl = url;
        this.__zproUpsellMethod = method;
        return xhrOpen.apply(this, arguments);
      };
      XHR.send = function () {
        var xhr = this;
        xhr.addEventListener(
          'load',
          function () {
            try {
              if (!isCartAddUrl(xhr.__zproUpsellUrl)) return;
              var m = String(xhr.__zproUpsellMethod || 'GET').toUpperCase();
              if (m !== 'POST' && m !== 'PUT') return;
              var text = xhr.responseText;
              if (!text) return;
              var data = JSON.parse(text);
              if (isMiniCartSubscriptionTierProductAddForUpsell(data)) {
                return;
              }
              if (dispatchZproUpsellFromCartResponse(data)) {
                activateUpsellLock();
              }
            } catch (e) {}
          },
          { once: true }
        );
        return xhrSend.apply(this, arguments);
      };
    }
  }

  /**
   * PDP `form.bg-product-form` (zpro-form): capture submit before apps.
   */
  function getSectionInnerHTMLFromFetchedSection(html, selector) {
    if (!html) return '';
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var sel = selector || '.shopify-section';
    var node = doc.querySelector(sel);
    return node ? node.innerHTML : '';
  }

  /** Mirror cart-drawer.renderContents section swap without opening the drawer (Monster/theme cart should stay closed until Proceed). */
  function updateCartSectionsWithoutOpeningDrawer(parsedState) {
    if (!parsedState || !parsedState.sections) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return;
    var inner = drawer.querySelector('.drawer__inner');
    if (inner && inner.classList.contains('is-empty')) inner.classList.remove('is-empty');
    if (parsedState.id != null) drawer.productId = parsedState.id;
    drawer.getSectionsToRender().forEach(function (section) {
      var sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      var html = parsedState.sections[section.id];
      if (!sectionElement || !html) return;
      sectionElement.innerHTML = getSectionInnerHTMLFromFetchedSection(html, section.selector);
    });
  }

  function getActiveZproVariantCard(form) {
    var zproRoot = form.closest('.zpro-form');
    return zproRoot && zproRoot.querySelector('.bg-variant.bg-variant--active');
  }

  function isUpsellPackConfiguredOnActiveCard(form) {
    var activeCard = getActiveZproVariantCard(form);
    return Boolean(activeCard && activeCard.hasAttribute('data-zpro-upsell-pack-configured'));
  }

  function buildZproCartPayloadFromForm(form) {
    var formData = new FormData(form);
    var mainId = parseInt(formData.get('id'), 10);
    var mainQty = parseInt(formData.get('quantity'), 10) || 1;
    var mainItem = { id: mainId, quantity: mainQty };
    var sp = formData.get('selling_plan');
    if (sp !== null && String(sp) !== '') {
      var spn = parseInt(sp, 10);
      if (!isNaN(spn)) mainItem.selling_plan = spn;
    }
    var props = {};
    formData.forEach(function (val, key) {
      var m = /^properties\[(.+)\]$/.exec(key);
      if (m) props[m[1]] = val;
    });
    if (Object.keys(props).length) mainItem.properties = props;

    return {
      items: [mainItem],
      showUpsellPopup: isUpsellPackConfiguredOnActiveCard(form),
    };
  }

  function onZproBgFormSubmit(evt) {
    var form = evt.target;
    if (!form || form.tagName !== 'FORM' || !form.classList.contains('bg-product-form')) return;
    if (!hasUpsellPopup()) return;
    var zproSection = form.closest('.shopify-section.fs-pdp');
    if (!zproSection || !zproSection.contains(form)) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    var submitBtn = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
    if (submitBtn && submitBtn.getAttribute('aria-disabled') === 'true') return;

    if (submitBtn) {
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.classList.add('loading');
    }

    var built = buildZproCartPayloadFromForm(form);
    window.__zproShowUpsellAfterCartAdd = built.showUpsellPopup;

    var payload = { items: built.items };
    var cart = getCartController();
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart
        .getSectionsToRender()
        .map(function (s) {
          return s.id;
        })
        .join(',');
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    } else if (document.getElementById('cart-icon-bubble')) {
      payload.sections = 'cart-icon-bubble';
      payload.sections_url = window.location.pathname;
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'zpro-upsell',
              productVariantId: built.items[0] ? built.items[0].id : null,
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'zpro-upsell',
            productVariantId: built.items[0] ? built.items[0].id : null,
            cartData: response,
          });
        }

        updateCartSectionsWithoutOpeningDrawer(response);

        /* Upsell UI: inline fetch hook dispatches zpro:upsell:added on /cart/add */
      })
      .catch(function (e) {
        console.error(e);
      })
      .finally(function () {
        try {
          delete window.__zproShowUpsellAfterCartAdd;
        } catch (e) {
          window.__zproShowUpsellAfterCartAdd = undefined;
        }
        if (submitBtn) {
          submitBtn.classList.remove('loading');
          submitBtn.removeAttribute('aria-disabled');
        }
        var cartEl = getCartController();
        if (cartEl && cartEl.classList && cartEl.classList.contains('is-empty')) {
          cartEl.classList.remove('is-empty');
        }
      });
  }

  document.addEventListener('submit', onZproBgFormSubmit, true);

  function normalizeCartImageUrl(val) {
    if (val == null || val === '') return '';
    if (typeof val === 'string') return val;
    if (typeof val === 'object') {
      if (typeof val.url === 'string') return val.url;
      if (typeof val.src === 'string') return val.src;
    }
    return '';
  }

  function lineItemImageUrl(line) {
    if (!line) return '';
    var u = normalizeCartImageUrl(line.image);
    if (u) return u;
    u = normalizeCartImageUrl(line.featured_image);
    if (u) return u;
    if (line.featured_image && typeof line.featured_image.url === 'string') return line.featured_image.url;
    return '';
  }

  function getImageFromResponse(response) {
    if (!response) return '';
    var u = normalizeCartImageUrl(response.image);
    if (u) return u;
    u = normalizeCartImageUrl(response.featured_image);
    if (u) return u;
    if (response.featured_image && typeof response.featured_image.url === 'string') return response.featured_image.url;

    var items = response.items;
    if (items && items.length) {
      var vid = response.variant_id != null ? String(response.variant_id) : null;
      if (vid) {
        for (var i = items.length - 1; i >= 0; i--) {
          var line = items[i];
          if (!line) continue;
          if (String(line.variant_id) === vid || String(line.id) === vid) {
            u = lineItemImageUrl(line);
            if (u) return u;
          }
        }
      }
      u = lineItemImageUrl(items[items.length - 1]);
      if (u) return u;
      u = lineItemImageUrl(items[0]);
      if (u) return u;
    }

    u = lineItemImageUrl(response);
    if (u) return u;
    return '';
  }

  function getImageFromActivePdpVariantCard() {
    var card = document.querySelector('.fs-pdp .zpro-form .bg-variant.bg-variant--active');
    if (!card) return '';
    var img = card.querySelector('.bg-variant-img img');
    if (!img) return '';
    var src = img.currentSrc || img.src || img.getAttribute('src');
    return src ? String(src).trim() : '';
  }

  function getTitleFromResponse(response) {
    if (!response) return '';
    if (response.product_title) return response.product_title;
    if (response.title) return response.title;
    if (response.items && response.items[0]) {
      var line = response.items[0];
      if (line.product_title) return line.product_title;
      if (line.title) return line.title;
    }
    return '';
  }

  function getCartController() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function getZproPdpProductForm() {
    return document.querySelector('.fs-pdp .zpro-form .bg-product-form');
  }

  function getSellingPlanIdForZproForm(form) {
    if (!form) return null;
    var zpro = form.closest('.zpro-form');
    if (!zpro) return null;
    var toggle = zpro.querySelector('.bg-subscription__toggle-input');
    if (!toggle || !toggle.checked) return null;
    var wrap = zpro.querySelector('.bg-subscription__frequency-wrap');
    if (!wrap || window.getComputedStyle(wrap).display === 'none') return null;
    var activeCard = zpro.querySelector('.bg-variant.bg-variant--active');
    var cardId = activeCard && activeCard.getAttribute('data-card-id');
    var variantId = activeCard && activeCard.getAttribute('data-variant-id');
    var freq = null;
    if (cardId) freq = wrap.querySelector('.bg-subscription__frequency[data-card-id="' + cardId + '"]');
    if (!freq && variantId) freq = wrap.querySelector('.bg-subscription__frequency[data-variant-id="' + variantId + '"]');
    if (!freq) freq = wrap.querySelector('.bg-subscription__frequency');
    var sel = freq && freq.querySelector('select[name="selling_plan"]');
    if (!sel || !sel.value) return null;
    var n = parseInt(sel.value, 10);
    return isNaN(n) ? null : n;
  }

  function applyUpsellSubscriptionHeadings(mount, form) {
    if (!mount) return;
    var zpro = form && form.closest('.zpro-form');
    var toggle = zpro && zpro.querySelector('.bg-subscription__toggle-input');
    var sub = Boolean(toggle && toggle.checked);
    mount.querySelectorAll('[data-bg-upsell-item]').forEach(function (item) {
      var ot = item.querySelector('.bg-upsell-product-item__heading--onetime');
      var st = item.querySelector('.bg-upsell-product-item__heading--sub');
      if (!st || !String(st.textContent || '').trim()) {
        if (ot) stripZproIsHidden(ot);
        if (st) st.classList.add('zpro-is-hidden');
        return;
      }
      if (sub) {
        if (ot) ot.classList.add('zpro-is-hidden');
        stripZproIsHidden(st);
      } else {
        stripZproIsHidden(ot);
        st.classList.add('zpro-is-hidden');
      }
    });
  }

  function clearZproUpsellProductsMount(popup) {
    var mount = popup && popup.querySelector('[data-zpro-upsell-products-mount]');
    if (mount) mount.innerHTML = '';
  }

  function applyUpsellPackVisibility(productsRoot, productId) {
    if (!productsRoot || productId == null || String(productId) === '') return;
    productsRoot.setAttribute('data-zpro-pack-active', String(productId));
    productsRoot.querySelectorAll('.bg-upsell-product-item').forEach(function (row) {
      var id = row.getAttribute('data-bundle-product-id');
      var show = String(id) === String(productId);
      if (show) {
        stripZproIsHidden(row);
      } else {
        row.classList.add('zpro-is-hidden');
        row.querySelectorAll('video').forEach(function (v) {
          try {
            v.pause();
          } catch (err) {}
        });
      }
    });
    productsRoot.querySelectorAll('[data-zpro-pack-select]').forEach(function (el) {
      var pid = el.getAttribute('data-zpro-pack-select');
      var sel = String(pid) === String(productId);
      el.classList.toggle('is-selected', sel);
      if (sel) el.setAttribute('aria-current', 'true');
      else el.removeAttribute('aria-current');
    });
  }

  function initUpsellPackVisibility(mount) {
    var productsRoot = mount && mount.querySelector('.bg-upsell-products');
    if (!productsRoot) return;
    var selectedName = productsRoot.querySelector('[data-zpro-pack-select].is-selected');
    var initialId = selectedName && selectedName.getAttribute('data-zpro-pack-select');
    if (!initialId) {
      var firstRow = productsRoot.querySelector('.bg-upsell-product-item[data-bundle-product-id]');
      initialId = firstRow && firstRow.getAttribute('data-bundle-product-id');
    }
    if (initialId) applyUpsellPackVisibility(productsRoot, initialId);
  }

  function getZproUpsellPriceSourceCard() {
    var formRoot = document.querySelector('.fs-pdp .zpro-form');
    if (!formRoot) return null;
    /* Upsell CTA always shows 2-pack (qty 2) discounted row, not the selected 1-pack */
    var twoPack = formRoot.querySelector('.zpro-form__variant.bg-variant[data-quantity="2"]');
    if (twoPack) return twoPack;
    return formRoot.querySelector('.zpro-form__variant.bg-variant.bg-variant--active');
  }

  function normalizeMoneyLabel(s) {
    return s == null ? '' : String(s).replace(/\s+/g, ' ').trim();
  }

  function getZproUpsellTwoPackSaveBadgeText() {
    var formRoot = document.querySelector('.fs-pdp .zpro-form');
    if (!formRoot) return '';
    var twoPack = formRoot.querySelector('.zpro-form__variant[data-quantity="2"]');
    if (!twoPack) return '';
    var el = twoPack.querySelector('.bg-variant-save');
    if (!el) return '';
    var t = normalizeMoneyLabel(el.textContent);
    if (!t) return '';
    if (/^save\s*0\s*%$/i.test(t)) return '';
    return t;
  }

  function getZproUpsellPriceLabels() {
    var priceCard = getZproUpsellPriceSourceCard();
    if (!priceCard) return { price: '', compare: '' };
    var pEl = priceCard.querySelector('[data-display-price]');
    var cEl = priceCard.querySelector('[data-display-compare]');
    var price = pEl ? normalizeMoneyLabel(pEl.textContent) : '';
    var compare = cEl ? normalizeMoneyLabel(cEl.textContent) : '';
    if (!price) price = normalizeMoneyLabel(priceCard.getAttribute('data-price'));
    if (!compare) compare = normalizeMoneyLabel(priceCard.getAttribute('data-compare-price'));
    return { price: price, compare: compare };
  }

  function getZproUpsellCurrencyCode() {
    var w = document.querySelector('.fs-pdp .pdp-afterpay-wrapper');
    var code = (w && w.getAttribute('data-currency')) || 'USD';
    return String(code).toUpperCase();
  }

  function formatZproUpsellAmountDigits(amount) {
    try {
      return new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function formatZproUpsellMoneyCents(cents) {
    var n = parseInt(cents, 10);
    if (isNaN(n)) return '';
    var amount = n / 100;
    var code = getZproUpsellCurrencyCode();
    if (code === 'AUD') {
      return '$' + formatZproUpsellAmountDigits(amount);
    }
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code,
        currencyDisplay: 'narrowSymbol',
      }).format(amount);
    } catch (e) {
      return '$' + formatZproUpsellAmountDigits(amount);
    }
  }

  function getZproUpsellBundleLineCents() {
    var card = getZproUpsellPriceSourceCard();
    if (!card) return { sale: NaN, compare: 0 };
    var sale = parseInt(card.getAttribute('data-price-cents'), 10);
    var compare = parseInt(card.getAttribute('data-compare-cents'), 10);
    return {
      sale: isNaN(sale) ? NaN : sale,
      compare: isNaN(compare) ? 0 : compare,
    };
  }

  function parseMoneyLabelToCents(label) {
    if (label == null || label === '') return NaN;
    var t = String(label)
      .replace(/\u00a0/g, ' ')
      .trim();
    var cleaned = t.replace(/[^\d.,-]/g, '');
    if (!cleaned) return NaN;
    var lastComma = cleaned.lastIndexOf(',');
    var lastDot = cleaned.lastIndexOf('.');
    var normalized;
    if (lastComma > lastDot) {
      normalized = cleaned.replace(/\./g, '').replace(',', '.');
    } else if (lastDot > lastComma) {
      normalized = cleaned.replace(/,/g, '');
    } else if (lastComma >= 0) {
      normalized = cleaned.replace(',', '.');
    } else {
      normalized = cleaned;
    }
    var n = parseFloat(normalized);
    return isNaN(n) ? NaN : Math.round(n * 100);
  }

  function readZproUpsellBundleCentsFromButton(btn) {
    if (!btn) return { sale: NaN, compare: 0 };
    var pe = btn.querySelector('[data-zpro-upsell-btn-price]');
    var ce = btn.querySelector('[data-zpro-upsell-btn-compare]');
    var sale = pe ? parseMoneyLabelToCents(normalizeMoneyLabel(pe.textContent)) : NaN;
    var compare = 0;
    if (ce && ce.style.display !== 'none') {
      var sTag = ce.querySelector('s');
      var cmpText = sTag ? sTag.textContent : ce.textContent;
      var c = parseMoneyLabelToCents(normalizeMoneyLabel(cmpText));
      if (!isNaN(c) && c > 0) compare = c;
    }
    return { sale: sale, compare: compare };
  }

  function applyUpsellSingleItemPriceRows(mount) {
    if (!mount) return;
    /* Match upgrade CTA: use displayed money (same as button), not data-price-cents — Liquid rounding can differ by a few cents from DOM. */
    var firstBtn = mount.querySelector('[data-zpro-upsell-add]');
    var labels = getZproUpsellPriceLabels();
    var saleCents = parseMoneyLabelToCents(labels.price);
    var compareCents = labels.compare ? parseMoneyLabelToCents(labels.compare) : NaN;
    if (isNaN(compareCents) || compareCents < 0) compareCents = 0;

    if (isNaN(saleCents) || saleCents <= 0) {
      var fromBtn = readZproUpsellBundleCentsFromButton(firstBtn);
      if (!isNaN(fromBtn.sale) && fromBtn.sale > 0) saleCents = fromBtn.sale;
    }
    if (!compareCents) {
      var cmpBtn = readZproUpsellBundleCentsFromButton(firstBtn);
      if (cmpBtn.compare > 0) compareCents = cmpBtn.compare;
    }
    if (isNaN(saleCents) || saleCents <= 0) {
      var cardLine = getZproUpsellBundleLineCents();
      if (!isNaN(cardLine.sale) && cardLine.sale > 0) saleCents = cardLine.sale;
      if (!compareCents && cardLine.compare > 0) compareCents = cardLine.compare;
    }

    var saleHalf = Math.round(saleCents / 2);
    var compareHalf = compareCents > 0 ? Math.round(compareCents / 2) : 0;
    var saveBadgeFromPdp = getZproUpsellTwoPackSaveBadgeText();

    mount.querySelectorAll('[data-bg-upsell-item]').forEach(function (item) {
      var row = item.querySelector('[data-zpro-upsell-single-row]');
      if (!row) return;
      var btn = item.querySelector('[data-zpro-upsell-add]');
      if (!btn || isNaN(saleCents) || saleCents <= 0) {
        row.classList.add('zpro-is-hidden');
        row.setAttribute('aria-hidden', 'true');
        return;
      }

      var saleEl = row.querySelector('[data-zpro-upsell-single-sale]');
      var compareEl = row.querySelector('[data-zpro-upsell-single-compare]');
      var saveEl = row.querySelector('[data-zpro-upsell-single-save]');

      if (saleEl) saleEl.textContent = formatZproUpsellMoneyCents(saleHalf);
      if (compareEl) {
        compareEl.textContent = '';
        if (compareHalf > saleHalf) {
          var st = document.createElement('s');
          st.textContent = formatZproUpsellMoneyCents(compareHalf);
          compareEl.appendChild(st);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (saveEl) {
        if (compareHalf > saleHalf) {
          var label = saveBadgeFromPdp;
          if (!label) {
            var pct = Math.round(((compareHalf - saleHalf) * 100) / compareHalf);
            label = 'Save ' + pct + '%';
          }
          saveEl.textContent = label;
          stripZproIsHidden(saveEl);
        } else {
          saveEl.textContent = '';
          saveEl.classList.add('zpro-is-hidden');
        }
      }

      stripZproIsHidden(row);
      row.setAttribute('aria-hidden', 'false');
    });
  }

  function applyUpsellUpgradeButtonPrices(mount) {
    if (!mount) return;
    var labels = getZproUpsellPriceLabels();
    var price = labels.price;
    var compare = labels.compare;

    mount.querySelectorAll('[data-zpro-upsell-add]').forEach(function (btn) {
      var sep = btn.querySelector('[data-zpro-upsell-btn-sep]');
      var priceEl = btn.querySelector('[data-zpro-upsell-btn-price]');
      var compareEl = btn.querySelector('[data-zpro-upsell-btn-compare]');
      if (!priceEl) return;
      if (!price) {
        if (sep) sep.style.display = 'none';
        priceEl.textContent = '';
        priceEl.style.display = 'none';
        if (compareEl) {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
        return;
      }
      if (sep) sep.style.display = '';
      priceEl.style.display = '';
      priceEl.textContent = price;
      if (compareEl) {
        compareEl.textContent = '';
        if (compare && compare !== price) {
          compareEl.style.display = '';
          var s = document.createElement('s');
          s.textContent = compare;
          compareEl.appendChild(s);
        } else {
          compareEl.style.display = 'none';
        }
      }
    });
    applyUpsellSingleItemPriceRows(mount);
  }

  function mountZproUpsellProductsFromActiveCard(popup) {
    var mount = popup.querySelector('[data-zpro-upsell-products-mount]');
    if (!mount) return;
    mount.innerHTML = '';
    var card = document.querySelector('.fs-pdp .zpro-form .bg-variant.bg-variant--active');
    if (!card) return;
    var root = card.querySelector('[data-zpro-upsell-inline-root]');
    if (!root) return;
    var inner = root.querySelector('.bg-upsell-products');
    if (!inner) return;
    mount.appendChild(inner.cloneNode(true));
    applyUpsellSubscriptionHeadings(mount, getZproPdpProductForm());
    initUpsellPackVisibility(mount);
    applyUpsellUpgradeButtonPrices(mount);
  }

  function postZproCartAddItems(items, activeEl) {
    if (!items || !items.length) return Promise.resolve(null);
    window.__zproSuppressNextUpsellPopup = true;
    var payload = { items: items };
    var cart = getCartController();
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart
        .getSectionsToRender()
        .map(function (s) {
          return s.id;
        })
        .join(',');
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function' && activeEl) {
        cart.setActiveElement(activeEl);
      }
    } else if (document.getElementById('cart-icon-bubble')) {
      payload.sections = 'cart-icon-bubble';
      payload.sections_url = window.location.pathname;
    }
    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        var response = result.data;
        if (!result.ok || (response && response.status)) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'zpro-upsell-cross',
              productVariantId: items[0] ? items[0].id : null,
              errors: response && (response.errors || response.description),
              message: response && response.message,
            });
          }
          return response;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'zpro-upsell-cross',
            productVariantId: items[0] ? items[0].id : null,
            cartData: response,
          });
        }
        updateCartSectionsWithoutOpeningDrawer(response);
        return response;
      })
      .catch(function (e) {
        console.error(e);
        throw e;
      })
      .finally(function () {
        try {
          delete window.__zproSuppressNextUpsellPopup;
        } catch (e) {
          window.__zproSuppressNextUpsellPopup = undefined;
        }
      });
  }

  function tryCloseThirdPartyCartDrawers() {
    if (!isUpsellLockActive && !window.__zproUpsellAwaitingUi) return;
    document.body.classList.remove('overflow-hidden');
    /* Do not dispatch synthetic Escape: our own keydown handler would hide the upsell bar (isTrusted is false for script-generated events). */

    var selectors = [
      '[class*="monster"]',
      '[id*="monster"]',
      '[class*="Monster"]',
      '[class*="slide-cart"]',
      '[class*="mu-"]',
      '[data-mu-cart]',
    ];
    selectors.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (node) {
          if (!node || !node.querySelectorAll) return;
          if (node.hasAttribute('data-zpro-upsell-popup') || node.hasAttribute('data-zpro-upsell-backdrop')) return;
          var closeBtn = node.querySelector(
            'button[aria-label*="Close"], [data-close-cart], .drawer__close, [class*="close-cart"]'
          );
          if (closeBtn && typeof closeBtn.click === 'function') {
            closeBtn.click();
          }
          if (typeof node.close === 'function') {
            try {
              node.close();
            } catch (e) {}
          }
        });
      } catch (e) {}
    });
  }

  function scheduleMonsterCartSuppression() {
    SUPPRESS_ATTEMPTS.forEach(function (ms) {
      setTimeout(tryCloseThirdPartyCartDrawers, ms);
    });
  }

  function startMonsterSuppressInterval() {
    if (window.__zproUpsellMonsterInterval) {
      clearInterval(window.__zproUpsellMonsterInterval);
    }
    var n = 0;
    window.__zproUpsellMonsterInterval = setInterval(function () {
      tryCloseThirdPartyCartDrawers();
      n += 1;
      if (n >= 36) {
        clearInterval(window.__zproUpsellMonsterInterval);
        window.__zproUpsellMonsterInterval = null;
      }
    }, 120);
  }

  function activateUpsellLock() {
    isUpsellLockActive = true;
    window.__zproUpsellAwaitingUi = false;
    document.documentElement.classList.add('zpro-upsell-lock');
    document.body.classList.add('zpro-upsell-lock');
    scheduleMonsterCartSuppression();
    startMonsterSuppressInterval();
  }

  function releaseUpsellLock() {
    isUpsellLockActive = false;
    window.__zproUpsellAwaitingUi = false;
    document.documentElement.classList.remove('zpro-upsell-lock');
    document.body.classList.remove('zpro-upsell-lock');
    if (window.__zproUpsellMonsterInterval) {
      clearInterval(window.__zproUpsellMonsterInterval);
      window.__zproUpsellMonsterInterval = null;
    }
  }

  function clearForcedPopupStyles(el) {
    if (!el || !el.style) return;
    ['display', 'visibility', 'opacity', 'transform', 'z-index', 'pointer-events'].forEach(function (p) {
      el.style.removeProperty(p);
    });
  }

  function stripZproIsHidden(el) {
    if (!el) return;
    el.classList.remove('zpro-is-hidden');
    el.className = (el.className || '').replace(/\bzpro-is-hidden\b/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function hideUpsellLayers() {
    var popup = document.querySelector('[data-zpro-upsell-popup]');
    var backdrop = document.querySelector('[data-zpro-upsell-backdrop]');
    if (popup) {
      clearZproUpsellProductsMount(popup);
      popup.removeAttribute('data-zpro-upsell-open');
      popup.classList.remove('is-active');
      popup.classList.add('zpro-is-hidden');
      clearForcedPopupStyles(popup);
    }
    if (backdrop) {
      backdrop.removeAttribute('data-zpro-upsell-open');
      backdrop.classList.add('zpro-is-hidden');
      backdrop.setAttribute('aria-hidden', 'true');
      clearForcedPopupStyles(backdrop);
    }
  }

  function onZproUpsellAdded(event) {
    var popup = document.querySelector('[data-zpro-upsell-popup]');
    if (!popup) return;

    var detail = (event && event.detail) || {};
    var response = detail.response || {};
    var title = getTitleFromResponse(response);
    var imageSrc = getImageFromResponse(response) || getImageFromActivePdpVariantCard();

    activateUpsellLock();

    var backdrop = document.querySelector('[data-zpro-upsell-backdrop]');

    if (backdrop) {
      stripZproIsHidden(backdrop);
      backdrop.setAttribute('data-zpro-upsell-open', 'true');
      backdrop.setAttribute('aria-hidden', 'false');
    }

    var titleEl = popup.querySelector('[data-zpro-upsell-title]');
    var imageEl = popup.querySelector('[data-zpro-upsell-image]');
    if (titleEl) titleEl.textContent = title;

    if (imageEl) {
      if (imageSrc) {
        imageEl.src = imageSrc;
        imageEl.alt = title;
        imageEl.classList.remove('zpro-is-hidden');
        imageEl.className = (imageEl.className || '').replace(/\bzpro-is-hidden\b/g, ' ').replace(/\s+/g, ' ').trim();
      } else {
        imageEl.classList.add('zpro-is-hidden');
      }
    }

    mountZproUpsellProductsFromActiveCard(popup);

    stripZproIsHidden(popup);
    popup.classList.add('is-active');
    popup.setAttribute('data-zpro-upsell-open', 'true');
  }

  document.addEventListener('zpro:upsell:added', onZproUpsellAdded);

  function dismissUpsellAndOpenCart(triggerEl) {
    releaseUpsellLock();
    hideUpsellLayers();

    if (typeof PROJ !== 'undefined' && PROJ.ajaxcart && typeof PROJ.ajaxcart.updateCart === 'function') {
      PROJ.ajaxcart.updateCart();
      return;
    }

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open(triggerEl || document.body);
      return;
    }

    var cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon) {
      cartIcon.click();
      return;
    }

    if (window.routes && window.routes.cart_url) {
      window.location.href = window.routes.cart_url;
    }
  }

  function initUpsellPopupUi() {
    var popup = document.querySelector('[data-zpro-upsell-popup]');
    if (!popup) return;

    if (!popup.dataset.zproUpsellCrossAddBound) {
      popup.dataset.zproUpsellCrossAddBound = 'true';
      popup.addEventListener('click', function (e) {
        var packEl = e.target.closest('[data-zpro-pack-select]');
        if (packEl && popup.contains(packEl)) {
          var um = popup.querySelector('[data-zpro-upsell-products-mount]');
          if (um && um.contains(packEl)) {
            e.preventDefault();
            var productsRoot = packEl.closest('.bg-upsell-products');
            var pid = packEl.getAttribute('data-zpro-pack-select');
            if (productsRoot && pid) applyUpsellPackVisibility(productsRoot, pid);
            return;
          }
        }
        var btn = e.target.closest('[data-zpro-upsell-add]');
        if (!btn || !popup.contains(btn)) return;
        if (btn.getAttribute('aria-disabled') === 'true' || btn.disabled) return;
        e.preventDefault();
        var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
        var qty = parseInt(btn.getAttribute('data-quantity'), 10) || 1;
        if (!vid) return;
        var form = getZproPdpProductForm();
        var item = { id: vid, quantity: qty };
        var plan = getSellingPlanIdForZproForm(form);
        if (plan != null) item.selling_plan = plan;
        btn.classList.add('loading');
        btn.setAttribute('aria-disabled', 'true');
        postZproCartAddItems([item], btn)
          .then(function (res) {
            if (res && res.status) return;
            btn.textContent = 'Added';
            btn.disabled = true;
            releaseUpsellLock();
            hideUpsellLayers();
          })
          .finally(function () {
            btn.classList.remove('loading');
            btn.removeAttribute('aria-disabled');
          });
      });
    }

    if (!popup.dataset.zproUpsellPackKeyBound) {
      popup.dataset.zproUpsellPackKeyBound = 'true';
      popup.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var packEl = e.target.closest('[data-zpro-pack-select]');
        if (!packEl || !popup.contains(packEl)) return;
        if (packEl.tagName === 'BUTTON') return;
        var um = popup.querySelector('[data-zpro-upsell-products-mount]');
        if (!um || !um.contains(packEl)) return;
        e.preventDefault();
        var productsRoot = packEl.closest('.bg-upsell-products');
        var pid = packEl.getAttribute('data-zpro-pack-select');
        if (productsRoot && pid) applyUpsellPackVisibility(productsRoot, pid);
      });
    }

    var proceedBtn = popup.querySelector('[data-zpro-upsell-proceed]');
    if (proceedBtn && !proceedBtn.dataset.zproUpsellUiBound) {
      proceedBtn.dataset.zproUpsellUiBound = 'true';
      proceedBtn.addEventListener('click', function () {
        dismissUpsellAndOpenCart(proceedBtn);
      });
    }

    var closeUpsellBtn = popup.querySelector('[data-zpro-upsell-close]');
    if (closeUpsellBtn && !closeUpsellBtn.dataset.zproUpsellUiBound) {
      closeUpsellBtn.dataset.zproUpsellUiBound = 'true';
      closeUpsellBtn.addEventListener('click', function () {
        dismissUpsellAndOpenCart(closeUpsellBtn);
      });
    }

    if (!document.documentElement.dataset.zproUpsellEscapeBound) {
      document.documentElement.dataset.zproUpsellEscapeBound = 'true';
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (!event.isTrusted) return;
        var p = document.querySelector('[data-zpro-upsell-popup]');
        if (!p || (!p.classList.contains('is-active') && !p.hasAttribute('data-zpro-upsell-open'))) return;
        releaseUpsellLock();
        hideUpsellLayers();
      });
    }

    var backdropEl = document.querySelector('[data-zpro-upsell-backdrop]');
    if (backdropEl && !backdropEl.dataset.zproUpsellBackdropBound) {
      backdropEl.dataset.zproUpsellBackdropBound = 'true';
      backdropEl.addEventListener('click', function () {
        releaseUpsellLock();
        hideUpsellLayers();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsellPopupUi);
  } else {
    initUpsellPopupUi();
  }
})();
